
import NGTConfigKey from "../../base/NGTConfigKey";
import Scenario from "../Scenario";
/**
 * InitializeScenariosCommand.js
 * 
 * Created on Oct 17, 2013, 2:36:14 PM
 *
 * @author Javier Quevedo-Fernandez for Ranj
 **/
export default class InitializeScenariosCommand {
    constructor(config, scenarioLibrary) {
        this._config = config;
        this._scenarioLibrary = scenarioLibrary;
    }

    execute(event) {
        this.initializeModel();
    }

    initializeModel() {
        const scenarios = this._config.getValue(NGTConfigKey.SCENARIOS);
        for (const scenarioNode of scenarios) {            
            var scenario = new Scenario();
            scenario.id = scenarioNode.scenarioID;
            scenario.name = scenarioNode.name;
            scenario.storyID = scenarioNode.storyID;
            scenario.availableIcon = scenarioNode.availableIcon;
            scenario.completedIcon = scenarioNode.completedIcon;
            scenario.castIds = scenarioNode.castIds;

            this._scenarioLibrary.addScenario(scenario);
        }
    }
}